// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price[data-v-6ead8428]{font-weight:500}.primary[data-v-6ead8428]{color:#333}.secondary[data-v-6ead8428]{color:#fd595e}.white[data-v-6ead8428]{color:#fff}.small[data-v-6ead8428]{font-size:1.6rem}.medium[data-v-6ead8428]{font-size:1.7rem}.large[data-v-6ead8428]{font-size:2.4rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
